import { showActionSheet } from '../pages/mobile/components/ActionSheet';
import { showToast } from '../pages/mobile/components/Toast';
import type { AgreementSceneDocItem } from '../api/agreement-doc';
import i18n from '../i18n';
import { stripAgreementHtmlThemeColors } from './agreement-html-theme';

/** RICH_TEXT：fileUrl / content 为 HTML，底部弹层展示 */
export function showAgreementRichTextSheet(doc: AgreementSceneDocItem) {
  const html = stripAgreementHtmlThemeColors(String(doc.content || doc.fileUrl || '').trim());
  if (!html) {
    showToast(i18n.Common.AgreementContentEmpty);
    return;
  }

  let sheet: { close: () => void } | null = null;
  sheet = showActionSheet({
    zIndex: 300,
    title: () => <div class="font-bold color-D">{doc.name || i18n.Common.Agreement}</div>,
    content: () => (
      <div
        class="flex-column"
        style={{
          height: '65vh',
          overflow: 'hidden',
          'box-sizing': 'border-box',
          // 抵消 .action-sheet-body 的 padding-bottom: 100px
          'margin-bottom': '-84px',
          'padding-bottom': '16px',
        }}
      >
        <div
          class="agreement-rich-text-sheet font-s-S color-D"
          style={{
            flex: 1,
            'min-height': 0,
            'overflow-y': 'auto',
            'line-height': '24px',
            '-webkit-overflow-scrolling': 'touch',
          }}
          innerHTML={html}
        />
        <button
          class="primary-btn btn-rounded width-100"
          style={{ 'flex-shrink': 0, 'margin-top': '16px', height: '50px' }}
          onclick={() => sheet?.close()}
        >
          {i18n.Common.Close}
        </button>
      </div>
    ),
  });
}
